export const canvas_designs = [
  {
    value: "ig",
    label: "Default Post",
    width: 512,
    height: 512,
  },
  {
    value: "ig",
    label: "Instagram Post",
    width: 512,
    height: 512,
  },
  {
    value: "fb",
    label: "Facebook Post",
    width: 512,
    height: 512,
  },
  {
    value: "tsap",
    label: "Whatsapp Post",
    width: 512,
    height: 512,
  },
];
